import { IQService } from 'angular';
import { IHttpService, IPromise } from 'angular';
import { IServiceModel } from "../../typings/board/ControllerResponse";
import { ServiceControllerStatus } from "../../typings/board/ServiceProcess";
import { Operation } from '../../typings/board/Models';

export const MANAGE_SERVICE = "manageService";

export class ManageService {
    static $inject = ["$http", "$q"];
    constructor(private $http: IHttpService, private $q: IQService) { }

    servicesToWatch(): ng.IPromise<IServiceModel[]> {
        return this.$http.get<IServiceModel[]>("api/manage/ServicesToWatch").then(response => response.data);
    }

    status(service = "BoardEngine"): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/status?service=${service}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }

    statusWeb(webSite): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/statusWeb?webSite=${webSite}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }

    start(service: string): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/start?service=${service}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }

    stop(service: string): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/stop?service=${service}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }

    restart(service: string): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/restart?service=${service}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }

    kill(service: string): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/kill?service=${service}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }

    executeOperation(applicationPoolName: string, operation: Operation): IPromise<ServiceControllerStatus> {
        return this.$http.get<ServiceControllerStatus>(`api/manage/executeOperation?applicationPoolName=${applicationPoolName}&operation=${operation}`).then(
            response => response.data,
            reason => this.extractError(reason));
    }


    private extractError(reason: { data: { message: any } }) {
        return this.$q.reject(reason.data.message);
    }

}


// WEBPACK FOOTER //
// ./app/manage/manage.service.ts